import { cn } from "@/lib/utils";

export type ProductSaleStockBadgeProps = {
  remain: number;
  low?: boolean;
  out?: boolean;
  variant?: "default" | "compact";
  className?: string;
};

export function ProductSaleStockBadge({
  remain,
  low,
  out,
  variant = "default",
  className,
}: ProductSaleStockBadgeProps) {
  const isLow = low ?? (remain > 0 && remain <= 3);
  const isOut = out ?? remain === 0;

  if (variant === "compact") {
    return (
      <span
        className={cn(
          "inline-flex h-6 min-w-[2.5rem] items-center justify-center rounded-full border px-2 text-xs font-semibold",
          isOut
            ? "border-red-200 bg-red-50 text-red-700"
            : isLow
              ? "border-amber-200 bg-amber-50 text-amber-700"
              : "border-emerald-200 bg-emerald-50 text-emerald-700",
          className
        )}
        title={`${remain} stock`}
      >
        {remain}
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold border",
        isOut
          ? "border-red-200 bg-red-50 text-red-600"
          : isLow
            ? "border-amber-200 bg-amber-50 text-amber-700"
            : "border-emerald-200 bg-emerald-50 text-emerald-700",
        className
      )}
      title={`${remain} stock`}
    >
      {isOut ? "Out" : (
        <>
          <span className="font-bold">{remain}</span>
          <span className="text-[9px] font-normal opacity-70">stock</span>
        </>
      )}
    </span>
  );
}

